<template>
    <div>
        <label class="label">{{ $t('modals.patient_profile.profile.request.email_head') }}</label>
        <div class="tabhead">
            <form-wrapper class="practice-information-form">
                <form-row>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.email.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.email.insurance_plans.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.email.document.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.email.document.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.email.provider.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.email.provider.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.email.address.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.email.address.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </form-wrapper>
        </div>

        <!-- Records Needed -->
        <div class="section">
            <h3 class="hipa-title">{{ $t('modals.patient_profile.profile.request.record') }}</h3>
            <div class="checkbox-group">
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_one') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_two') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_three') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_four') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_five') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_six') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_seven') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_eight') }}</p>
                </label>
            </div>
        </div>

        <!-- HIPAA Section -->
        <form-wrapper class="practice-information-form">
            <form-row>
                <form-cell width="full">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.hipaa.authorization.label') }}
                    </label>
                    <select-input
                        class="schedule-apply__input"
                        :placeholder="$t('forms.patient_profile.fields.hipaa.authorization.placeholder')"
                        :hasAutofocus="true"
                        :options="locationOptions"
                        @change="changeCurrentLocationId($event)"
                    ></select-input>
                </form-cell>
            </form-row>
            <h3 class="hipa-titles">{{ $t('modals.patient_profile.profile.request.range') }}</h3>
            <form-row>
                <form-cell width="half">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.label') }}
                    </label>
                    <text-field
                        :placeholder="$t('forms.patient_profile.fields.date_range.insurance_plans.placeholder')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="memberId"
                        type="date"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.document.label') }}
                    </label>
                    <text-field
                        :placeholder="$t('forms.patient_profile.fields.date_range.document.placeholder')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="memberId"
                        type="date"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="full">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.provider.label') }}
                    </label>
                    <select-input
                        class="schedule-apply__input"
                        :placeholder="$t('forms.patient_profile.fields.date_range.provider.placeholder')"
                        :hasAutofocus="true"
                        :options="requestnOption"
                        @change="changeCurrentLocationId($event)"
                    ></select-input>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="full">
                    <textarea-field
                        :label="$t('forms.patient_profile.fields.profile.additional.label')"
                        :placeholder="$t('forms.patient_profile.fields.profile.additional.placeholder')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="message"
                        @change="change($event)"
                    ></textarea-field>
                </form-cell>
            </form-row>
        </form-wrapper>

        <div class="submit">
            <button class="request">
                <common-icon name="send" size="medium"></common-icon>
                Submit Request
            </button>
        </div>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'

    export default {
        name: 'request-records-form',
        mixins: [FormMixin, HandleRequestMixin],
        data() {
            return {
                selectedDocument: null,
                locationOptions: [{ label: 'General HIPAA Authorization (expires 15/01/2026)', value: 1 }],
                requestnOption: [
                    { label: 'Continuing Care', value: 1 },
                    { label: 'Specialist Referral', value: 2 },
                    { label: 'Second Opinion', value: 3 },
                    { label: 'Personal Records', value: 4 },
                    { label: 'Insurance Claim', value: 5 },
                    { label: 'Legal Proceeding', value: 6 },
                ],
            }
        },
    }
</script>

<style scoped>
    .label {
        font-weight: 500;
        display: block;
        margin-bottom: 8px;
        color: oklch(0.145 0 0);
        font-size: 16px;
    }

    .tabhead {
        padding-bottom: 25px;
        border-bottom: 1px solid #ddd;
    }

    .section {
        margin-bottom: 20px;
    }

    .hipa-title,
    .hipa-titles {
        font-size: 12px;
        font-weight: 500;
        color: oklch(0.145 0 0);
        margin: 10px 0px;
    }

    .hipa-titles {
        margin-top: 18px;
    }

    .checkbox-group {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px 20px;
        font-size: 14px;
        align-items: center;
    }

    .checkbox-group label {
        display: flex;
    }

    .checkbox-group label p {
        margin-left: 10px;
        color: oklch(0.145 0 0);
        font-size: 13px;
        font-weight: 500;
    }

    .submit {
        margin-top: 20px;
    }

    .request {
        background-color: oklch(0.546 0.245 262.881);
        border-radius: 8px;
        color: #fff;
        padding: 8px;
        opacity: 0.5;
        margin: 10px 0;
    }
    @media screen and (max-width: 600px) {
        .checkbox-group {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>
